<div
  class="column-container"
  [@fadeIn]="fadingIn"
  (@fadeIn.done)="fadeInDone($event.toState)"
  [@fadeOut]="fadingOut"
  (@fadeOut.done)="fadeOutDone($event.toState)"
>
  <h4 [matTooltip]="getHeaderTooltip()" matTooltipPosition="right">
    PRIMARY ARGUMENTS
  </h4>
  <div class="button-input-container">
    <div class="button-column">
      <div *ngFor="let pair of argValuePairs">
        <commands-ui-single-primary-arg-button
          [argValuePair]="pair"
          (activeChange)="emitArgs()"
        ></commands-ui-single-primary-arg-button>
      </div>
    </div>
    <div class="input-column">
      <div *ngFor="let pair of argValuePairs">
        <commands-ui-single-primary-arg-input
          [permaHidden]="isInputPermaHidden(pair)"
          [argValuePair]="pair"
          (valueChange)="emitArgs()"
        ></commands-ui-single-primary-arg-input>
      </div>
    </div>
  </div>
</div>
